import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { forwardRef, useRef, useState, useEffect, useImperativeHandle, isValidElement } from 'react';
import classnames from 'classnames';
import FocusTrap from 'focus-trap-react';
import { Breakpoints } from "../../Responsive/Breakpoints/Breakpoints";
import { IconButton } from "../../Button/IconButton/IconButton";
import { Overlay } from "../../Overlay/Overlay/Overlay";
import { Theme } from "../../Background/Theme/Theme";
import Utility from "../../Utility/Utility";
import styles from "./Popup.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var PopupControlComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("span", {
    className: styles.handleWrapper,
    ref: ref,
    children: props === null || props === void 0 ? void 0 : props.children
  });
});
export var Popup = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var _popupPos$offset, _popupPos$offset2;
  var children = _ref.children,
    handle = _ref.handle,
    _ref$config = _ref.config,
    config = _ref$config === void 0 ? {
      position: 'auto',
      offset: 15,
      hideClose: false
    } : _ref$config,
    _ref$popupClass = _ref.popupClass,
    popupClass = _ref$popupClass === void 0 ? '' : _ref$popupClass,
    _ref$popupCloseClass = _ref.popupCloseClass,
    popupCloseClass = _ref$popupCloseClass === void 0 ? '' : _ref$popupCloseClass,
    _ref$contentClass = _ref.contentClass,
    contentClass = _ref$contentClass === void 0 ? '' : _ref$contentClass,
    _ref$clickOutsideDeac = _ref.clickOutsideDeactivates,
    clickOutsideDeactivates = _ref$clickOutsideDeac === void 0 ? true : _ref$clickOutsideDeac;
  var isFirstRender = useRef(true);
  var timeoutID = useRef(null);
  var id = useRef(Utility.generateUID('popup'));
  var positionInitValue = {
    center: {
      x: 0,
      y: 0
    },
    width: 0,
    height: 0
  };
  var _useState = useState(positionInitValue),
    _useState2 = _slicedToArray(_useState, 2),
    target = _useState2[0],
    setTarget = _useState2[1];
  var _useState3 = useState(positionInitValue),
    _useState4 = _slicedToArray(_useState3, 2),
    popup = _useState4[0],
    setPopup = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    open = _useState6[0],
    setOpen = _useState6[1];
  var wrapperRef = useRef(null);
  var popupRef = useRef(null);
  useEffect(function () {
    if (window) {
      var closePopupOnResize = function closePopupOnResize() {
        return setOpen(false);
      };
      window.addEventListener('resize', closePopupOnResize);
      return function () {
        return window.removeEventListener('resize', closePopupOnResize);
      };
    }
  }, []);
  useEffect(function () {
    // Prevent setting focus on wrapper on page load.
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (open) {
      if (popupRef && popupRef.current) {
        popupRef.current.focus({
          preventScroll: true
        });
      }
    } else {
      if (wrapperRef && wrapperRef.current) {
        wrapperRef.current.focus();
      }
    }
  }, [open]);
  useImperativeHandle(forwardedRef, function () {
    return {
      togglePopup: togglePopup
    };
  });
  var openPopup = function openPopup() {
    if (!open) {
      setOpen(true);
      if (wrapperRef && wrapperRef.current) {
        setTarget(getElementMeasures(wrapperRef.current));
      }
      if (popupRef && popupRef.current) {
        setPopup(getElementMeasures(popupRef.current));
      }
    }
  };
  var closePopup = function closePopup() {
    setOpen(false);
  };
  var onBlur = function onBlur(event) {
    // Fixes Safari issue where popup closes immediately.
    if ((event === null || event === void 0 ? void 0 : event.relatedTarget) === null) {
      return;
    }
    timeoutID.current = setTimeout(function () {
      closePopup();
    }, 250);
  };
  var onFocus = function onFocus() {
    if (timeoutID && timeoutID.current) {
      clearTimeout(timeoutID.current);
    }
  };
  var getElementMeasures = function getElementMeasures(ref) {
    var measures = ref.getBoundingClientRect();
    var measuresX = isNaN(measures.x) ? measures.left : measures.x;
    var measuresY = isNaN(measures.y) ? measures.top : measures.y;
    return {
      center: {
        x: measuresX + measures.width / 2,
        y: measuresY + measures.height / 2 + window.pageYOffset
      },
      width: measures.width,
      height: measures.height
    };
  };
  var getPopupPosition = function getPopupPosition() {
    var offset = {
      left: 0,
      right: 0,
      top: 0
    };
    var defaultClosePosition = {
      offset: offset,
      pos: null,
      top: -2000,
      left: -2000
    };
    var defaultOpenMobilePosition = {
      offset: offset,
      pos: null,
      top: 0,
      left: 0,
      bottom: 0,
      right: 0
    };
    if (!config || !config.offset) {
      if (open) {
        return defaultOpenMobilePosition;
      } else {
        return defaultClosePosition;
      }
    }
    if (open) {
      if (window.innerWidth >= Breakpoints.tablet.min) {
        var top = 0;
        var left = 0;
        var pos = config.position ? config.position : 'top';
        var triangleHeight = 10;
        top = target.center.y;
        left = target.center.x - popup.width / 2;
        if (left < 0) {
          offset.left = Math.abs(left);
        }
        if (left + popup.width > window.innerWidth) {
          offset.right = Math.abs(left + popup.width - window.innerWidth);
        }
        if (pos === 'auto') {
          if (top + target.height / 2 + config.offset + popup.height > window.innerHeight && top - target.height / 2 > config.offset + popup.height + triangleHeight + window.pageYOffset) {
            pos = 'top';
          } else {
            pos = 'bottom';
          }
        }
        if (pos === 'top') {
          offset.top = -target.height / 2 - config.offset - popup.height;
        }
        if (pos === 'bottom') {
          offset.top = target.height / 2 + config.offset;
        }
        return {
          offset: offset,
          pos: pos,
          top: top + offset.top,
          left: left - -offset.left - offset.right
        };
      }
      return defaultOpenMobilePosition;
    }
    return defaultClosePosition;
  };
  var togglePopup = function togglePopup() {
    if (!open) {
      openPopup();
    } else {
      closePopup();
    }
  };
  var props = {
    'aria-describedby': open ? id.current : undefined,
    'aria-expanded': open ? 'true' : 'false'
  };
  var popupPos = getPopupPosition();
  var popupStyle = {
    top: popupPos.top,
    left: popupPos.left,
    bottom: popupPos.bottom,
    right: popupPos.right
  };
  var offsetLeft = ((_popupPos$offset = popupPos.offset) === null || _popupPos$offset === void 0 ? void 0 : _popupPos$offset.left) || 0;
  var offsetRight = ((_popupPos$offset2 = popupPos.offset) === null || _popupPos$offset2 === void 0 ? void 0 : _popupPos$offset2.right) || 0;
  var arrowStyle = {
    left: popup.width / 2 - 5 + -offsetLeft + offsetRight
  };
  var clonedPopupControl = null;
  if ( /*#__PURE__*/isValidElement(handle)) {
    clonedPopupControl = /*#__PURE__*/React.cloneElement(handle, props);
  }
  return /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx(PopupControlComponent, {
      ref: wrapperRef,
      children: clonedPopupControl
    }), /*#__PURE__*/_jsx(Overlay, {
      children: /*#__PURE__*/_jsx(Theme, {
        theme: "lightBackground",
        children: /*#__PURE__*/_jsx(FocusTrap, {
          active: open,
          focusTrapOptions: {
            clickOutsideDeactivates: clickOutsideDeactivates,
            onDeactivate: closePopup,
            returnFocusOnDeactivate: true
          },
          children: /*#__PURE__*/_jsx("div", {
            className: classnames(styles.popup, popupClass),
            style: popupStyle,
            ref: function ref(popup) {
              popupRef.current = popup;
            },
            onBlur: onBlur,
            onFocus: onFocus,
            role: "grid" // Allows onFocus/onBlur of children to bubble up.
            ,
            tabIndex: -1,
            id: id.current,
            children: /*#__PURE__*/_jsxs("div", {
              role: "row",
              className: classnames(styles.popupContent, contentClass),
              children: [/*#__PURE__*/_jsx("span", {
                style: arrowStyle,
                className: classnames(styles.popupArrow, popupPos.pos === 'top' && styles['popupArrowBottom'])
              }), /*#__PURE__*/_jsx("div", {
                role: "cell",
                children: children
              }), /*#__PURE__*/_jsx("div", {
                className: classnames(styles.popupClose, (config === null || config === void 0 ? void 0 : config.hideClose) && styles['popupCloseHidden'], popupCloseClass),
                role: "cell",
                children: /*#__PURE__*/_jsx(IconButton, {
                  onClick: closePopup,
                  "aria-label": "Click to close popup",
                  icon: "close",
                  size: "14px"
                })
              })]
            })
          })
        })
      })
    })]
  });
});